import { RangeFilter, ContentType, AnyContent, FilterType, LiveArticleData, ContentItem } from 'interfaces'
import { StockContentProvider } from 'interfaces/Content/StockContentProvider'
import { SortBy } from 'services/content/util'
import { ContentFeedType } from 'shared'

export interface ScrollConfiguration {
  element?: Element
  useWindow?: boolean
}

export type ContentGridViewPaging = {
  [range: string]: {
    [filter: string]: {
      page: number
      hasNext: boolean
    }
  }
}

export interface FetchableProps {
  page: number
  range: RangeFilter
  only?: ContentType
  sortBy?: SortBy
  stockSource?: StockContentProvider
  onFetched(content: AnyContent[]): void
  onFailed(error: any): void
}

export interface ContentGridViewProps {
  sourceId: string
  filter: FilterType
  contentTypes: ContentType[]
  feedType?: ContentFeedType
  hideSorting?: boolean
  hideFilters?: boolean
  isStream?: boolean
  favoritesMode?: boolean
  sourcesHash?: string
  className?: string
  scroll?: ScrollConfiguration
  range?: RangeFilter
  itemWidth?: number
  errorElement?: React.ReactElement<any>
  skipContentCardsFeatureChecks?: boolean
  noContentRangeCheck?: boolean
  noContentTypeCheck?: boolean
  hideRangeFilter?: boolean
  hideEmptyCards?: boolean
  filtersContainerClassName?: string
  preventTopOverflow?: boolean
  onFilterChange(filter: FilterType): void
  onRangeChanged?(range: RangeFilter): boolean | void
  onItemPinned?(content: AnyContent): void
  onItemShared?(content: AnyContent): void | boolean
  onSourceClick?(content: AnyContent, by: string): void
  onFeedClick?(content: AnyContent): void
  onContentItemClick?(content: ContentItem): void
}

// screen width: columns
export const GRID_BREAKPOINTS = {
  860: 2,
  1210: 3,
  1484: 4,
  1780: 5,
  2058: 6,
  2340: 7,
  2586: 8
}
